import { PropsWithChildren } from 'react';
import cn from 'classnames';
import styles from './button.module.scss';

export enum ButtonVariant {
  primary = 'primary',
  secondary = 'secondary',
  primaryV2 = 'primary-v2',
  secondaryV2 = 'secondary-v2',
  v3 = 'v3',
}

export type ButtonProps = PropsWithChildren & {
  variant?: ButtonVariant;
  disabled?: boolean;
  onClick?: () => void;
  type?: 'submit' | 'button';
  className?: string;
};

/**
 * Button
 * @param variant
 * @param disabled
 * @param onClick
 * @param className
 */
export const Button = ({
  variant = ButtonVariant.primary,
  disabled = false,
  children,
  onClick,
  type,
  className,
}: ButtonProps) => {
  return (
    <button
      className={cn(styles.button, styles[`button-${variant}`], className)}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
